<template>
  <SurveyOnlineRoomsList :signalRSocket="signalRSocket" v-if="signalRSocket"/>
</template>

<script>
import SurveyOnlineRoomsList from "@/components/online-rooms-list/SurveyOnlineRoomsList.vue";
import * as SignalR from "@microsoft/signalr";

export default {
  name: "survey-online-rooms-list",
  components: {
    SurveyOnlineRoomsList,
  },
  data() {
      return {
          signalRSocket: false,
      }
  },
  async mounted() {
    await this.signalRInitialize();
  },
  methods: {
    async signalRInitialize() {
      try {
        const socket = new SignalR.HubConnectionBuilder()
          .withUrl(process.env.VUE_APP_ONLINE_HUB)
          .withAutomaticReconnect()
          .build();

        socket.connection.onclose = async (error) => {
          if (error !== undefined) this.$log(error);

          this.$log("Reconnecting...");
          this.signalRSocket = false;
          await this.signalRInitialize();
        };

        await socket.start();

        this.signalRSocket = socket;
      } catch (err) {
        this.$log("Error, reconnecting...");

        setTimeout(() => {
          this.signalRInitialize();
        }, 1000);
      }
    }
  },
};
</script>
